<template>
  <figure class="m-0">
    <!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg ref="svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 410 216" style="enable-background:new 0 0 410 216;" xml:space="preserve">
    <rect x="0.5" y="1" class="field-bg" width="409" height="214"/>
    <path class="field-lines" d="M409.5,1H0.5v214h129v0.5h3V215H202v0.5h6V215h69.5v0.5h3V215h129V1z M2.5,213V3h127v210H2.5z M132.5,213V3H202
        v210H132.5z M208,213V3h69.5v210H208z M407.5,213h-127V3h127V213z"/>
    <g class="player-position defensive-specialist">
        <g class="player-position setter">
            <g class="position">
                <path class="position" d="M49,39.5c-1.1,0-1.6,0.5-1.6,1.1c0,0.7,0.7,1.1,1.6,1.3l0.9,0.2c1.8,0.4,3,1.3,3.1,3c0,1.9-1.5,3.1-4,3.1
                    s-4-1.1-4.1-3.3H47c0.1,1,0.9,1.5,2,1.5s1.8-0.5,1.8-1.3c0-0.7-0.6-1-1.7-1.3L48,43.6c-1.7-0.4-2.8-1.3-2.8-2.8
                    c0-1.9,1.6-3.1,3.9-3.1c2.3,0,3.8,1.3,3.8,3.1h-2.1C50.7,40,50.1,39.5,49,39.5z"/>
                <circle id="Ellipse_824_4_" class="position" cx="35.1" cy="43" r="7.5"/>
            </g>
        </g>
        <g class="player-position libero">
            <g class="position">
                <path class="position" d="M45.2,102.9h2.2v8.4h4.4v1.8h-6.5v-10.2H45.2z"/>
                <circle id="Ellipse_821_4_" class="position" cx="35.1" cy="108" r="7.5"/>
            </g>
        </g>
        <g>
        <g class="player-position outside-hitter">
            <g class="position">
            <path class="position" d="M49.8,178.2c-2.7,0-4.8-1.9-4.8-5.2s2.1-5.2,4.8-5.2s4.8,1.9,4.8,5.2S52.5,178.2,49.8,178.2z M49.8,169.7
                c-1.6,0-2.6,1.2-2.6,3.3s1,3.3,2.6,3.3s2.6-1.2,2.6-3.3S51.4,169.7,49.8,169.7z"/>
            <path class="position" d="M56.2,167.9h2.2v4.2h4.4v-4.2h2.1v10.2h-2.1v-4.2h-4.4v4.2h-2.2V167.9z"/>
            <circle id="Ellipse_828_4_" class="position" cx="35.1" cy="173" r="7.5"/>
            </g>
        </g>
        <g class="player-position middle-blocker">
            <g class="position">
                <path class="position" d="M169.5,102.8l2.7,6.9h0.1l2.9-6.8h2.7l-0.2,10.2h-2.1l0.1-6.6h-0.1l-2.7,6.5h-1.4l-2.5-6.6h-0.1l-0.1,6.7
                    h-2.1l0.2-10.2L169.5,102.8z"/>
                <path class="position" d="M179.8,102.9l4.1,0.1c2.2,0,3.4,1.1,3.3,2.7c0,1.2-0.8,1.9-1.9,2.2v0.1c1.2,0.1,2.2,1,2.2,2.5
                    c0,1.6-1.3,2.8-3.6,2.8l-4.4-0.1L179.8,102.9z M183.5,107.3c0.9,0,1.5-0.5,1.6-1.3c0-0.7-0.5-1.2-1.5-1.3H182v2.5L183.5,107.3z
                    M183.6,111.4c1.2,0,1.7-0.5,1.7-1.2c0-0.8-0.6-1.4-1.7-1.5h-1.8v2.7H183.6z"/>
                <circle id="Ellipse_821_5_" class="position" cx="156.1" cy="108" r="7.5"/>
            </g>
        </g>
        <g class="player-position opposite-right-side">
            <g class="position">
                <circle id="Ellipse_824_5_" class="position" cx="156.1" cy="43" r="7.5"/>
                <path class="position" d="M170.4,48.2c-2.7,0-4.7-2-4.7-5.3c0.1-3.3,2.1-5.2,4.9-5.2c2.7,0,4.7,2,4.7,5.3
                    C175.2,46.4,173.1,48.3,170.4,48.2z M170.5,39.7c-1.6,0-2.6,1.1-2.6,3.3s1,3.3,2.5,3.4c1.6,0,2.6-1.1,2.6-3.3
                    C173.1,40.9,172.1,39.7,170.5,39.7z"/>
            </g>
            <g class="position">
                <path class="position" d="M166.2,167.9h4c2.3,0,3.7,1.3,3.7,3.3c0,1.4-0.6,2.4-1.8,2.9l2.2,4h-2.4l-1.9-3.6h-1.6v3.6h-2.2V167.9z
                    M169.9,172.7c1.2,0,1.8-0.5,1.8-1.5s-0.6-1.6-1.8-1.6h-1.5v3.1H169.9z"/>
                <path class="position" d="M175.4,167.9h2.2v4.2h4.4v-4.2h2.1v10.2H182v-4.2h-4.4v4.2h-2.2L175.4,167.9L175.4,167.9z"/>
                <circle id="Ellipse_828_5_" class="position" cx="156.1" cy="173" r="7.5"/>
            </g>
        </g>
        </g>
    </g>
    </svg>

  </figure>
</template>

<script>
import positionsLogic from './AthletePositionsLogic';
export default {
    mixins: [ positionsLogic ]
}
</script>
